import { combineReducers } from 'redux';

import mainAppBar from '../app-bar/reducer';
import mainSideBar from '../nav-bar/reducer';
import users from '../users-mgmt/reducer';
import personas from '../personas-mgmt/reducer';
import stations from '../stations-mgmt/reducer';
import system from '../system/reducer';
import login from '../login/reducer';
import forgetPassword from '../forget-password/reducer';
import resetPassword from '../reset-password/reducer';
import fastData from '../fast-data/reducer';
import stationFastData from '../station-fastdata/reducer';
import userStations from '../system/reducer/UserStationsReducers';
import slowData from '../slow-data/reducer';
import healthData from '../health-data/reducer';
import downloadRequests from '../download-request/reducer';
import stationStatistics from '../station-statistics/reducer';
import portfolioFaultOverview from '../portfolio-fault-overview/reducer';
import errorReports from '../error-reports/reducer';
import systemDeviceFaults from '../system-device-faults/reducer'

const app = combineReducers({
  mainAppBar,
  mainSideBar,
  users,
  personas,
  stations,
  system,
  login,
  fastData,
  stationFastData,
  userStations,
  slowData,
  forgetPassword,
  resetPassword,
  healthData,
  downloadRequests,
  stationStatistics,
  errorReports,
  systemDeviceFaults,
  portfolioFaultOverview
});

export default app;